import Result from './Result';

export default class List {
	constructor(data, config = {}) {

		let defaultConfig = {
			selectorSortBtn: '.js-dc-list-sortby',
			cssClassAsc: 'asc',
			cssClassDesc: 'desc',
			attrKey: 'data-dc-sortby-key'
		};
		this.config = Object.assign(defaultConfig, config);

		this.results = new Result(config.resultsContainer, data, {});
		this.sortby = {
			key: 'title',
			direction: 'asc'
		};
		this.btns = [];

		this.#setupBtns();
	}

	#setupBtns() {
		let _this = this;
		let btns = Array.prototype.slice.call(this.config.container.querySelectorAll(this.config.selectorSortBtn));

		if (btns.length > 0) {
			btns.forEach((btn) => {
				let key = btn.getAttribute(this.config.attrKey);
				if (key) {
					this.btns.push({
						elem: btn,
						key: key,
						selected: false,
						direction: btn.classList.contains(_this.config.cssClassAsc) ? 'desc' : 'asc',
					});
				}
			});
		}

		this.btns.forEach(btn => {
			btn.elem.addEventListener('click', (e) => {
				e.preventDefault();
				this.#btnHandler(btn);
			});
		});
	}

	#btnHandler(btn) {
		this.sortby.key = btn.key;
		this.sortby.direction = btn.direction;

		if (btn.direction == 'asc') {
			btn.direction = 'desc';
		} else {
			btn.direction = 'asc';
		}

		this.#btnCssClassHandler(btn);

		this.results.sortFilesBy(this.sortby.key, this.sortby.direction);
		this.results.reorderDomFiles();
	}

	#btnCssClassHandler(clickBtn) {
		this.btns.forEach(btn => {
			btn.elem.classList.remove(this.config.cssClassAsc);
			btn.elem.classList.remove(this.config.cssClassDesc);
		});

		if (clickBtn.direction == 'asc') {
			clickBtn.elem.classList.add(this.config.cssClassDesc);
		} else {
			clickBtn.elem.classList.add(this.config.cssClassAsc);
		}
	}
}